import Box from '@mui/material/Box';
import TableHeader from '../../../components/TableHeader/TableHeader';
import useEmployeeSelection from '../../../hooks/useEmployeeSelection';
import styles from './styles.module.css';
import Taskboard from '../../../components/TaskboardReport/Taskboard';

export default function TaskboardReport() {
    const { currentEmployee, emplist, onCurrentEmployeeChange } =
        useEmployeeSelection();

    return (
        <Box className={styles.mainContainer}>
            <TableHeader
                heading="Taskboard Leave Report"
                emplist={emplist}
                handleChange={onCurrentEmployeeChange}
                currentEmployee={currentEmployee.employee_id}
            />
            <Taskboard currentEmployeeId={currentEmployee.employee_id} />
        </Box>
    );
}
